const selectPayment = state => {
  return {
    ...state.payment
  };
};
const selectCurrentPage = state => {
  //var p = state.payment.page;
  //alert(JSON.stringify(state.payment));
  return {
    ...state.payment.page
  };
};
const selectPaymentList = state => {
  return {
    ...state.payment.paymentList
  };
};
const selectPaymentSum = state => {
  return {
    ...state.payment.paymentSumData
  };
};

export { selectPayment, selectCurrentPage, selectPaymentList,selectPaymentSum };
